module.exports = __webpack_public_path__ + "img/qr.152338e8.png";